export default {
  thisVerbFoundIn: 'This verb was found in:',
  verbWithoutCognitiveLevel: 'Verb without cognitive level.',
  alreadyHasOrderMessage: 'This {entity} already has {competence} in that order.',

  // ========== SentenceForm ==========
  insertOrCreateTooltip: 'Enter sentence directly or use "creation" mode',
  insert: 'Insert',
  action: 'Action',
  object: 'Object',
  condition: 'Condition',
  verb: 'Verb',
  content: 'Content',
  context: 'Context',
  information: 'Information',
  whatDoes: 'What does?',
  whatWillKnow: 'What will they know how to do?',
  actionToPerform: 'The action to',
  perform: 'perform',
  expressedIn: 'Expressed in',
  indicative: 'indicative',
  indicativeExample: '(designs, communicates)',
  reflectsAction: 'Reflects an',
  assessableAction: 'assessable action',
  observableAction: 'and observable in present time',
  aboutWhat: 'About What',
  aboutWhatPerforms: 'performs the action (object)',
  whatToEvaluate: 'What will I ask them to evaluate, manage, analyze, report?',
  forWhat: 'For What?',
  inWhatContext: 'In What Context',
  attitudes: 'Attitudes (Transversal Competencies)',
  whatMeans: 'What means, scenarios, situations, normative contexts?',
  consideredInRelation: 'Considered in relation to the object/content and the action to be performed',
  selectTaxonomy: '--Select Taxonomy--',
  customizeVerb: 'Customize',
  noVerbsMatch: 'No verbs match your search.',
  verbSavedWithoutLevel: 'This verb will be saved without cognitive level.',
  recommendGenericCompetence: 'It is recommended to respond to a Generic Competence.',
  selectVerb: 'Select a verb',
  mustSelectVerb: 'You must select a verb.',
  contentCannotBeEmpty: 'Content cannot be empty.',
  conditionCannotBeEmpty: 'Condition cannot be empty.',
  cognitiveLevel: 'Cognitive Level',
}